import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { ToastData } from './toast.model';
import { ErrorService } from '@service/error.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-toast',
  templateUrl: 'toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {
  showTimestamp: boolean = this.data.showTimestamp;
  errorTimestamp$: Observable<string> = this.errorService.getTimestamp();

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData,
    private toastRef: MatSnackBarRef<ToastComponent>,
    private errorService: ErrorService
  ) {}

  close(): void {
    this.toastRef.dismiss();
  }
}
